import Vue from 'vue';
import _ from 'lodash';
import {
    GET_CAR_SHORT_REQUEST,
    GET_CAR_SHORT_SUCCESS,
    GET_CAR_SHORT_FAILURE,
    GET_CAR_LETTER_REQUEST,
    GET_CAR_LETTER_SUCCESS,
    GET_CAR_LETTER_FAILURE
} from '../mutationTypes';

const state = {
    loading: false,
    carShort: [],
};

const mutations = {
    [GET_CAR_SHORT_REQUEST](state) {
        state.loading = true;
    },
    [GET_CAR_SHORT_SUCCESS](state, res) {
        state.loading = false;

        state.carShort = _.map(_.flattenDepth(_.map(res.first_letter,
            item => item.cars_short), 1), i => ({
            cities: [],
            label: `${i.short_name} (${i.short_province})`,
            short_name: i.short_name,
            short_id: i.short_id
        }));
    },
    [GET_CAR_SHORT_FAILURE](state) {
        state.loading = false;
    },
    [GET_CAR_LETTER_REQUEST](state) {
        state.loading = true;
    },
    [GET_CAR_LETTER_SUCCESS](state, res) {
        state.loading = false;
        _.each(state.carShort, (item) => {
            if (item.short_id === res.id) {
                Object.assign(item, {cities: _.map(res.cars_letter, cItem => ({
                    label: `${cItem.letter_name} (${cItem.letter_city})`,
                    short_id: cItem.letter_id,
                    short_name: cItem.letter_name
                }))});
            }
        });
    },
    [GET_CAR_LETTER_FAILURE](state) {
        state.loading = false;
    },
};

export const actions = {
    async getCarShort({ commit }) {
        commit(GET_CAR_SHORT_REQUEST);

        const res = await Vue.$ajax.get('getCarShort');

        if (!res.errorType) {
            commit(GET_CAR_SHORT_SUCCESS, res);
        } else {
            commit(GET_CAR_SHORT_FAILURE);
        }
    },
    async getCarLetter({ commit }, name) {
        commit(GET_CAR_LETTER_REQUEST);

        let shortId = '';
        _.each(state.carShort, (item) => {
            if (item.short_name === name) {
                shortId = item.short_id;
            }
        });

        const res = await Vue.$ajax.get('getCarLetter', {
            short_id: shortId
        });

        if (!res.errorType) {
            commit(GET_CAR_LETTER_SUCCESS, {
                cars_letter: res.cars_letter,
                id: shortId
            });
        } else {
            commit(GET_CAR_LETTER_FAILURE);
        }
    },
};

export default {
    state,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/carNo.js